import React, { useCallback } from 'react';
import { Box } from '@chakra-ui/react';
import { useEventPositionContext } from '../../../lib';

export const EventWrapper = ({ children, ...rest }) => {
	const { event, slotStart } = rest;
	const { eventRefs } = useEventPositionContext();

	const handleRef = useCallback(
		(ref) => (eventRefs.current[`${event.id}#${slotStart?.toString()}`] = ref),
		[event.id, slotStart, eventRefs]
	);
	return <Box ref={handleRef}>{children}</Box>;
};
